/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import {
  TPL_MANIFEST,
  TPL_MANIFEST_DRAFT,
  TPL_MANIFEST_FILE_UPLOAD,
  MANIFEST_UPDATE_ORDER_STATUS,
  TPL_MANIFEST_CHECK_ORDER,
} from "../constants/url.constant";

import { API } from "../api";

export const GET_ALL_TPL_MANIFEST = "GET_ALL_TPL_MANIFEST";
export const DELETE_TPL_MANIFEST = "DELETE_TPL_MANIFEST";

export const uploadAWBFile = (fileData) => {
  return async (dispatch) => {
    try {
      return await API.post(TPL_MANIFEST_FILE_UPLOAD, fileData);
    } catch (error) {
      throw error;
    }
  };
};

export const updateManifestOrdersStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(MANIFEST_UPDATE_ORDER_STATUS, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const createTPLManifest = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(TPL_MANIFEST, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const createDraftTPLManifest = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(TPL_MANIFEST_DRAFT, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const checkOrders = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(TPL_MANIFEST_CHECK_ORDER, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getAllTPLManifest = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(TPL_MANIFEST, {
        params: params
      });
      dispatch({
        type: GET_ALL_TPL_MANIFEST,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getTplManifestById = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${TPL_MANIFEST}/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateTplManifest = (id, data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${TPL_MANIFEST}/${id}`, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeTplManifestOrder = (orderId, id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${TPL_MANIFEST}/${orderId}/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeTPLManifest = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${TPL_MANIFEST}/${id}`);
      dispatch({
        type: DELETE_TPL_MANIFEST,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

const initialState = {
  columns: [],
  data: [],
  totalRows: 0,
  order: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_TPL_MANIFEST:
      return {
        ...state,
        columns: payload.columns,
        data: payload.rows,
        totalRows: payload.count
      };
    case DELETE_TPL_MANIFEST:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        data: state.data.filter((bag) => bag.id !== payload)
      };
    default:
      return state;
  }
}
